import { JSX } from 'react'

import HappyFaceEmoji from './emojis/HappyFaceEmoji'
import HeartEmoji from './emojis/HeartEmoji'
import HeyThereEmoji from './emojis/HeyThereEmoji'
import IndexFingerUpEmoji from './emojis/IndexFingerUpEmoji'
import RaisedHandsEmoji from './emojis/RaisedHandsEmoji'
import ShinyStarsEmoji from './emojis/ShinyStarsEmoji'
import ThumbUpEmoji from './emojis/ThumbUpEmoji'

export type EmojiType = 'thumbUp' | 'raisedHands' | 'heart' | 'heyThere' | 'indexFingerUp' | 'happyFace' | 'shinyStars'

export const emojis: Record<EmojiType, JSX.Element> = {
  heart: <HeartEmoji />,
  heyThere: <HeyThereEmoji />,
  indexFingerUp: <IndexFingerUpEmoji />,
  raisedHands: <RaisedHandsEmoji />,
  thumbUp: <ThumbUpEmoji />,
  happyFace: <HappyFaceEmoji />,
  shinyStars: <ShinyStarsEmoji />,
}

export const Emoji = (props: { type: EmojiType }): JSX.Element => {
  return emojis[props.type]
}
